module.exports = __webpack_public_path__ + "images/if6_schnellrechner_scenario_2.svg?4585f246c1a469ce02cb0d1f7d083141";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/if6_schnellrechner_scenario_2.svg
// module id = F6FA
// module chunks = 0